import { useMediaQuery } from '@patrianna/shared-hooks'
import { memo, useEffect } from 'react'

import { trackSPPlacementDisplayed } from 'src/analyticActions/common/trackPaymentSnowplow'
import ShopTileLarge from 'src/components/ShopTile/Large'
import ShopTileSmall from 'src/components/ShopTile/Small'
import TitleWithDivider from 'src/components/TitleWithDivider'
import { useAppSelector } from 'src/store/hooks'
import { sweepstakeEnabledSelector } from 'src/store/modules/appConfig/selectors'
import { getUpdatedSpecialOffers } from 'src/store/modules/shop/selectors'
import { isLoggedInSelector } from 'src/store/modules/user/selectors'

type Props = {
  snowplowPayFlow?: string
  snowplowPlacementName?: string
}

export default memo(function SpecialOffers({ snowplowPayFlow, snowplowPlacementName }: Props) {
  const specialOffers = useAppSelector(getUpdatedSpecialOffers)
  const matchesShopTile = useMediaQuery('md')
  const loggedIn = useAppSelector(isLoggedInSelector)
  const sweepstakeEnabled = useAppSelector(sweepstakeEnabledSelector)

  useEffect(() => {
    if (specialOffers.length) {
      trackSPPlacementDisplayed({
        paymentFlow: snowplowPayFlow,
        placementName: snowplowPlacementName,
        paymentProduct: 'multiple',
      })
    }
  }, [specialOffers.length, snowplowPayFlow, snowplowPlacementName])

  if (!specialOffers.length) {
    return null
  }

  return (
    <div>
      <TitleWithDivider title='Special Offers' />
      {specialOffers.map((offer) =>
        matchesShopTile ? (
          <ShopTileSmall
            key={offer?.code}
            loggedIn={loggedIn}
            offer={offer}
            sweepstakeEnabled={sweepstakeEnabled}
            dataTestId='store-special-offer-item'
            snowplowPayFlow={snowplowPayFlow}
            snowplowPlacementName={snowplowPlacementName}
          />
        ) : (
          <ShopTileLarge
            key={offer?.code}
            offer={offer}
            sweepstakeEnabled={sweepstakeEnabled}
            dataTestId='store-special-offer-item'
            snowplowPayFlow={snowplowPayFlow}
            snowplowPlacementName={snowplowPlacementName}
          />
        ),
      )}
    </div>
  )
})
